/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getServiceAuth.defs'
export { main as default } from './getServiceAuth.defs'
